import React from 'react';
import { Box, Container, Typography, List, ListItem, ListItemText, useTheme, Link } from '@mui/material';
import { Scrollbars } from 'react-custom-scrollbars-2';
import config from '../config/config';

const TermsAndConditions = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: '100%',
                py: 2,
                position: 'relative',
                overflow: 'hidden',
                flexGrow: 1,
                marginRight: -1,
            }}
        >
            {/* Background Plate */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '99%',
                    height: '400px',
                    // background: `linear-gradient(145deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                    borderRadius: '0 0 16px 16px',
                    boxShadow: '0px 20px 50px rgba(0, 0, 0, 0.2)',
                    zIndex: 0,
                }}
            ></Box>
            {/* <Box sx={{
                position: 'relative',
                zIndex: 1,
                height: '100%',
            }}>

            </Box> */}
            <Scrollbars>
                <Container maxWidth="md"
                    sx={{
                        backgroundColor: "background.default",
                        border: 1,
                        borderColor: "divider",
                        borderRadius: "0 0 16px 16px",
                    }}
                >
                    <Typography variant="h3" align="center" sx={{ fontWeight: 'bold', mb: 6 }}>
                        Terms and Conditions
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 4 }}>
                        Welcome to Glassyfied! By using our website and services, you agree to be bound by these Terms and Conditions.
                        Please read them carefully to understand your rights, responsibilities, and limitations.
                    </Typography>

                    <Section title="1. Overview of Our Service">
                        Glassyfied is an AI-driven platform providing educational assistance and resources to students, teachers, and
                        institutions. Our service allows users to ask questions, access study materials, and utilize AI tools for
                        academic support.
                    </Section>

                    <Section title="2. Acceptance of Terms">
                        By accessing or using our services, you agree to these Terms and Conditions and our Privacy Policy. If you do
                        not agree, please do not use our services.
                    </Section>

                    <Section title="3. Eligibility">
                        Glassyfied is intended for users aged 13 or older. If you are under 18, you must have parental or guardian
                        permission to use our service. Accounts may be suspended or terminated if eligibility requirements are not met.
                    </Section>

                    <Section title="4. User Accounts">
                        Users may be required to create an account to access certain features. You are responsible for maintaining
                        the confidentiality of your login credentials and for all activities that occur under your account. Please
                        notify us immediately if you suspect any unauthorized use of your account.
                    </Section>

                    <Section title="5. User Conduct and Responsibilities">
                        Users agree not to misuse our platform. Prohibited behaviors include, but are not limited to:
                        <List>
                            <ListItem><ListItemText primary="Uploading harmful or malicious files" /></ListItem>
                            <ListItem><ListItemText primary="Using the platform for illegal activities" /></ListItem>
                            <ListItem><ListItemText primary="Harassing or defaming others" /></ListItem>
                            <ListItem><ListItemText primary="Accessing the platform through unauthorized methods" /></ListItem>
                            <ListItem><ListItemText primary="Attempting to disrupt the service" /></ListItem>
                        </List>
                    </Section>

                    <Section title="6. Content Ownership and Intellectual Property">
                        All content provided by Glassyfied, including text, graphics, and software, is owned by us or our licensors
                        and is protected by intellectual property laws. You may not reproduce, distribute, or create derivative
                        works from our content without express permission.
                    </Section>

                    <Section title="7. User-Generated Content">
                        Glassyfied may allow users to submit content, such as questions or feedback. By submitting content, you grant
                        us a non-exclusive, royalty-free license to use, reproduce, and display your content in connection with our
                        services. You are responsible for ensuring that your content complies with these Terms and applicable laws.
                    </Section>

                    <Section title="8. Privacy Policy">
                        Your use of Glassyfied is also governed by our Privacy Policy, which outlines how we collect, use, and protect
                        your personal information. By using our services, you consent to our data practices as described in the Privacy Policy.
                    </Section>

                    <Section title="9. Limitation of Liability">
                        Glassyfied and its affiliates are not liable for any direct, indirect, incidental, or consequential damages
                        resulting from your use of our platform. This includes, but is not limited to, damages for loss of data,
                        interruption of service, or issues related to the accuracy of AI responses.
                    </Section>

                    <Section title="10. Disclaimer of Warranties">
                        Glassyfied provides its services on an “as-is” and “as-available” basis. We make no warranties or
                        representations about the accuracy or completeness of the platform’s content or the reliability of any AI
                        responses. Use of our service is at your own risk.
                    </Section>

                    <Section title="11. Modifications to the Terms">
                        Glassyfied reserves the right to modify these Terms and Conditions at any time. Any changes will be posted on
                        our website, and your continued use of the platform constitutes acceptance of the updated terms.
                    </Section>

                    <Section title="12. Termination">
                        Glassyfied reserves the right to suspend or terminate your account at our discretion if you violate these
                        Terms or engage in prohibited conduct. Termination does not affect any rights or obligations accrued prior to termination.
                    </Section>

                    <Section title="13. Contact Information">
                        If you have questions about these Terms and Conditions or require support, you may contact us at:
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            Email: <Link href={`mailto:${config.supportMail}`} color="primary.dark">{config.supportMail}</Link>
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            Phone: <Link href={`tel:${config.phoneNumber}`} color="primary.dark">{config.phoneNumber}</Link>
                        </Typography>
                    </Section>

                    <Typography variant="body2" sx={{ mt: 4, textAlign: 'center', color: 'text.secondary' }}>
                        These Terms and Conditions were last updated on 24-Jan-2025. Please review regularly for updates.
                    </Typography>
                </Container>
            </Scrollbars>
        </Box>
    );
};

const Section = ({ title, children }) => (
    <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
            {title}
        </Typography>
        <Box variant="body1">
            {children}
        </Box>
    </Box>
);

export default TermsAndConditions;
